import "./infosection.css";

const InfoBoxes = () => {
  return (
    <div className="central-container">
      <div className="info-box-row">
        <div className="info-box">
          <h3>Root Cause Intelligence</h3>
          <p className="info-box-lower">
            Pinpoints issues across complex systems using LLMs and telemetry context, reducing mean time to resolution (MTTR).
          </p>
        </div>
        <div className="info-box info-box-green-shadow">
          <h3>Autonomous Remediation</h3>
          <p className="info-box-lower">
            Executes automated workflows and scripts to resolve incidents instantly — keeping systems reliable without manual intervention.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfoBoxes;
